import BaseRepository from "@/baseRepository/BaseRepository";
const pagesResource = `/api/v1/pages`;
const publishResource = `/api/v1/pagepublishrequests`;

export default{
  
  showPublishRequest(baseURL = {}, headers = {}, params = {},paramsSerializer){
    return BaseRepository.get(`${publishResource}`, {
      baseURL,
      headers,
      params,
      paramsSerializer
    });
  },
  sendpublishRequest(obj, baseURL = {}, headers = {}, params = {}){
    return BaseRepository.post(`${publishResource}`, obj, {
      baseURL,
      headers,
      params
    });

  },
  getPagesWithFilter(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${pagesResource}/filter`, {
      baseURL,
      headers,
      params
    });
  },
  getPages(baseURL = {}, headers = {}, params = {}, paramsSerializer) {
    return BaseRepository.get(`${pagesResource}`, {
      baseURL,
      headers,
      params,
      paramsSerializer
    });
  },
  createPages(obj={},baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}`,obj, {
      baseURL,
      headers,
      params
    });
  },
  deletePages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${pagesResource}/${id}`, {
      baseURL,
      headers,
      params
    });
  },
  getPagesById(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${pagesResource}/${id}`, {
      baseURL,
      headers,
      params
    });
  },
  editPages(id,obj={},baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${pagesResource}/${id}`,obj, {
      baseURL,
      headers,
      params
    });
  },
  disablePages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}/${id}/disable`,{},{
      baseURL,
      headers,
      params
    });
  },
  enablePages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}/${id}/enable`,{},{
      baseURL,
      headers,
      params
    });
  },
  approvePages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}/${id}/approve`,{},{
      baseURL,
      headers,
      params
    });
  },
  unapprovePages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}/${id}/unapprove`,{},{
      baseURL,
      headers,
      params
    });
  },
  enableCommentPages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}/${id}/enable-comment`,{},{
      baseURL,
      headers,
      params
    });
  },
  disableCommentPages(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${pagesResource}/${id}/disable-comment`,{},{
      baseURL,
      headers,
      params
    });
  },
  getUniquePage(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${pagesResource}/by-uniquepagename`,{
      baseURL,
      headers,
      params
    });
  },
  pagesList(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
}